import { Skeleton } from "@deputy-ai/ui/skeleton/Skeleton";
import type { ComponentPropsWithoutRef } from "react";

export function PageSkeleton(props: ComponentPropsWithoutRef<"div">) {
  return (
    <div className="space-y-4 p-6" {...props}>
      {Array.from({ length: 4 }).map((_, index) => (
        <Skeleton key={index} className="h-5 w-full" />
      ))}
    </div>
  );
}

export default PageSkeleton;
